<ng-container *ngIf="!!iconArray && iconArray?.length">
  <div class="jb-logo-grid-item jb-max-width center-l">
    <h3 class="mt4">{{ header }}</h3>
    <div class="jb-grid gr-unset cb-grid-gap mv4 mv5-l">
      <jb-logo-grid-item
        *ngFor="let image of iconArray"
        [src]="image.src"
        [alt]="image.alt"
        class="pb2 pb0-ns"
      >
      </jb-logo-grid-item>
    </div>
  </div>
</ng-container>
